document.addEventListener("DOMContentLoaded", function() {
$('.btn--quick-add.add-to-set').on('click',function (){
    const variantId = $(this).attr('data-product-id');
    const productVariantsJson = JSON.parse($(this).closest('.product-grid-item').find('[type="application/json"]')[0].textContent);
    const productJson = JSON.parse($(this).closest('.product-grid-item').find($('.product-json [type="application/json"]'))[0].textContent);
    const slectedVariantJson = productVariantsJson.find(variant => variant.id == parseInt(variantId));
    const variantImage = $(this).closest('.product-grid-item').find($('.swatch__button.active .swatch__label')).attr('style');
    const variantSlider = $(this).closest('.product-grid-item').find('.variant-slider');
    const activeSwatchElement = variantSlider.find('.swatch__button.swiper-slide.active')[0];
    let activeSwatch;
    if (activeSwatchElement) {
        activeSwatch = activeSwatchElement.innerHTML;
    } else {
        activeSwatch = "";
    }
    
    let setCart = localStorage.getItem("BananaSetCart");
    // localStorage.setItem('Show_product_bar', false);
    if(setCart != null ){
        let jsonSetCart = JSON.parse(setCart);
        let hasInCart = jsonSetCart.find(element => element.id == parseInt(variantId));
        let quantities = jsonSetCart.map(item => item.quantity);
        let quantitiesSum = 0;
        let quantitiesLimit = parseInt(SetCart.max_product_set);
        quantities.forEach(function (quantity) {
            quantitiesSum += quantity;
        })
        if(hasInCart){
            let setCartItem = {
                id: hasInCart.id,
                quantity: hasInCart.quantity+1,
                position: hasInCart.position,
                variantJson: slectedVariantJson,
                variantImage: variantImage,
                productJson: productJson,
                variantSwatchBg: activeSwatch
            }
            jsonSetCart.splice(hasInCart.position, 0, setCartItem);
            jsonSetCart.splice(hasInCart.position+1, 1);

            if(quantitiesSum < quantitiesLimit){
                localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
                setTimeout(initSetCart(), 500);
                $('.set-cart-error').hide();
            }else{
                $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
                $('.set-cart-error').show();
            }
        }else{
            let setCartItem = {
                id: parseInt(variantId),
                quantity: 1,
                position: jsonSetCart.length,
                variantJson: slectedVariantJson,
                variantImage: variantImage,
                productJson: productJson,
                variantSwatchBg: activeSwatch
            }
            jsonSetCart.push(setCartItem)
            if(quantitiesSum < quantitiesLimit){
                localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
                setTimeout(initSetCart(), 500);
                $('.set-cart-error').hide();
            }else{
                $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
                $('.set-cart-error').show();
            }
        }

    }else{
        let setCartItem = {
            id: parseInt(variantId),
            quantity: 1,
            position: 0,
            variantJson: slectedVariantJson,
            variantImage: variantImage,
            productJson: productJson,
            variantSwatchBg: activeSwatch
        }
        setCart = [setCartItem];
        localStorage.setItem('BananaSetCart', JSON.stringify(setCart));
        setTimeout(initSetCart(), 500);
    }
})
$(document).on('click','.js-quick-view-set-btn',function (){
    const variantId = $(this).closest('.product__form').find($('input[name="id"]')).val();
    const productVariantsJson = JSON.parse($(this).closest('.product__form').find('.product-variant-json [type="application/json"]')[0].textContent);
    const productJson = JSON.parse($(this).closest('.product__form').find($('.product-json [type="application/json"]'))[0].textContent);
    const slectedVariantJson = productVariantsJson.find(variant => variant.id == parseInt(variantId));
    const variantImage = $(this).closest('.product__form').find('.swatch__input:checked').closest('.swatch__button').find($('.swatch__label')).attr('style');
    let setCart = localStorage.getItem("BananaSetCart");
    // localStorage.setItem('Show_product_bar', false);
    if(setCart != null ){
        let jsonSetCart = JSON.parse(setCart);
        let hasInCart = jsonSetCart.find(element => element.id == parseInt(variantId));
        let quantities = jsonSetCart.map(item => item.quantity);
        let quantitiesSum = 0;
        let quantitiesLimit = parseInt(SetCart.max_product_set);
        quantities.forEach(function (quantity) {
            quantitiesSum += quantity;
        })
        if(hasInCart){
            let setCartItem = {
                id: hasInCart.id,
                quantity: hasInCart.quantity+1,
                position: hasInCart.position,
                variantJson: slectedVariantJson,
                variantImage: variantImage,
                productJson: productJson
            }
            jsonSetCart.splice(hasInCart.position, 0, setCartItem);
            jsonSetCart.splice(hasInCart.position+1, 1);

            if(quantitiesSum < quantitiesLimit){
                localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
                setTimeout(initSetCart(), 500);
                $('.set-cart-error').hide();
            }else{
                $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
                $('.set-cart-error').show();
            }
        }else{
            let setCartItem = {
                id: parseInt(variantId),
                quantity: 1,
                position: jsonSetCart.length,
                variantJson: slectedVariantJson,
                variantImage: variantImage,
                productJson: productJson
            }
            jsonSetCart.push(setCartItem)
            if(quantitiesSum < quantitiesLimit){
                localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
                setTimeout(initSetCart(), 500);
                $('.set-cart-error').hide();
            }else{
                $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
                $('.set-cart-error').show();
            }
        }

    }else{
        let setCartItem = {
            id: parseInt(variantId),
            quantity: 1,
            position: 0,
            variantJson: slectedVariantJson,
            variantImage: variantImage,
            productJson: productJson
        }
        setCart = [setCartItem];
        localStorage.setItem('BananaSetCart', JSON.stringify(setCart));
        setTimeout(initSetCart(), 500);
    }
    $.magnificPopup.close();
});


initSetCart();
function initSetCart(){
    let setCart = localStorage.getItem("BananaSetCart");
    let setCartCount = 0;
    let setCartTotal = 0;
    let setCartDiscout = 0;
    let setCartDiscoutValue = 0;
    let discounts = JSON.parse(localStorage.getItem("BananaSetCartDiscount"));
    let quantitiesLimit = parseInt($('.js-set-cart-list').attr('data-max-product'));
    if(discounts == null){
        discounts = [
            {quantity:3,value:7},
            {quantity:4,value:10},
            {quantity:5,value:15},
            {quantity:6,value:20}
        ];
    }

    let activeDiscount = discounts[0];
    if(setCart != null ){
        let jsonSetCart = JSON.parse(setCart);
        jsonSetCart.reverse();
        if(jsonSetCart.length > 0) {
            function formatMoney(value) {
                const cents = (parseFloat(value) / 100).toFixed(2);
                const formattedValue = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
                }).formatToParts(cents);
            
                const currencySymbol = formattedValue.find(part => part.type === 'currency');
                const formattedPrice = formattedValue
                .filter(part => part.type !== 'currency')
                .map(part => part.value)
                .join('');
            
                return `${currencySymbol.value}${formattedPrice}`;
            }
            $('.js-set-cart-list .cart-items-list')[0].innerHTML = ''
            jsonSetCart.forEach(function (item) {
                setCartCount = setCartCount + item.quantity;
                setCartTotal = setCartTotal + (item.quantity * item.variantJson.price)
                let variantTitle = '';
                const setProductItemFormated = formatMoney(item.variantJson.price);
                let variantImgae = ``;
                if(item.variantJson.public_title != null){
                    variantTitle = item.variantJson.public_title;
                }
                if(item.variantSwatchBg != undefined){
                    variantImgae = item.variantSwatchBg;
                }
                let coverProductImage = item.variantJson.featured_image ? item.variantJson.featured_image.src : item.productJson.featured_image ;
                let setCartItem = `
                <div class="cart-item" data-index="${item.position}" data-variant="${item.variantJson.id}">
                    <div class="cart-item-image">
                        <img src="${coverProductImage}" alt="${item.productJson.title}">
                    </div>
                    <div class="cart-item-information">
                        <div class="cart-item-information-item">
                            <div class="title">${item.productJson.title}</div>
                            <div class="price">${setProductItemFormated}
                            </div>
                        </div>
                        <div class="cart-item-information-item quantity-wrapper">
                            <div class="variant"><div class="dataSwatch-bg">${variantImgae}</div>${variantTitle}</div>
                            <div class="quantity">
                                <button class="quantity-button js-set-quantity-button quantity-minus"></button>
                                <input class="quantity-input js-set-quantity-input" type="number" value="${item.quantity}" min="0" max="${quantitiesLimit}">
                                <button class="quantity-button js-set-quantity-button quantity-plus">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
                $('.js-set-cart-list .cart-items-list').append(setCartItem);
                $('.js-set-cart-list').show();
                $('.js-set-cart-list').closest('.set-creator-cart-content').removeClass('empty');
                $('.js-set-cart-empty').hide();
            })
            discounts.forEach(function (discount, index) {
                if (setCartCount >= discount.quantity) {
                    setCartDiscout = (setCartTotal * discount.value / 100);
                    setCartDiscoutValue = discount.value;
                    if (index != discounts.length - 1) {
                        activeDiscount = discounts[index + 1];
                    } else {
                        activeDiscount = discounts[index];
                    }

                }
            });
            function formatMoney(value) {
                const cents = (parseFloat(value) / 100).toFixed(2);
                const formattedValue = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
                }).formatToParts(cents);
            
                const currencySymbol = formattedValue.find(part => part.type === 'currency');
                const formattedPrice = formattedValue
                .filter(part => part.type !== 'currency')
                .map(part => part.value)
                .join('');
            
                return `${currencySymbol.value}${formattedPrice}`;
            }
            const setCartTotalFormated = formatMoney(setCartTotal);
            const setCartDiscoutFormated = formatMoney(setCartDiscout);
            const cartTotalMinusCartDiscout = setCartTotal - setCartDiscout;
            const setTotalPriceFormated = formatMoney(cartTotalMinusCartDiscout);
            $('.js-cart-info')[0].innerHTML = SetCart.cart_discount_text.replace('{count}', activeDiscount.quantity).replace('{value}', activeDiscount.value);
            $('.js-set-subtotal .value')[0].innerHTML = setCartTotalFormated;
            $('.js-set-discount .value')[0].innerHTML = setCartDiscoutFormated;
            $('.js-set-discount .label')[0].innerHTML = SetCart.cart_discount_label.replace('{value}', setCartDiscoutValue);
            $('.js-set-total .value')[0].innerHTML = setTotalPriceFormated;
            $('.js-set-cart-count').html(setCartCount);
            $('.js-set-cart-count').show();
        }else{
            discounts.forEach(function (discount, index) {
                if (setCartCount >= discount.quantity) {
                    setCartDiscout = (setCartTotal * discount.value / 100);
                    setCartDiscoutValue = discount.value;
                    if (index != discounts.length - 1) {
                        activeDiscount = discounts[index + 1];
                    } else {
                        activeDiscount = discounts[index];
                    }

                }
            });
            $('.js-cart-info')[0].innerHTML = SetCart.cart_discount_text.replace('{count}', activeDiscount.quantity).replace('{value}', activeDiscount.value);
            $('.js-set-cart-list').hide();
            $('.js-set-cart-list').closest('.set-creator-cart-content').addClass('empty');
            $('.js-set-cart-empty').show();
            $('.js-set-cart-count').hide();
        }

    }else{
        $('.js-set-cart-list').hide();
        $('.js-set-cart-list').closest('.set-creator-cart-content').addClass('empty');
        $('.js-set-cart-empty').show();
        $('.js-set-cart-count').hide();
    }
}
$(document).on('click','.js-set-quantity-button',function (){
    const button = $(this);
    const input = $(this).closest('.quantity').find('.quantity-input');
    const value = parseInt(input.val());
    let quantities = $('.js-set-cart .quantity-input')
    let quantitiesSum = 0;
    let quantitiesLimit = parseInt($('.js-set-cart-list').attr('data-max-product'));
    quantities.each(function () {
        quantitiesSum += parseInt($(this).val());
    })

       if(button.hasClass('quantity-minus')){
           if(value > 0){
               input.val(value-1)
               input.trigger('change')
           }
       } else {
           if(quantitiesSum < quantitiesLimit) {
               if(value < quantitiesLimit) {
                   input.val(value + 1)
                   input.trigger('change')
               }
           }else{
               $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
               $('.set-cart-error').show();
           }
       }

});
$(document).on('input','.js-set-quantity-input',function (){
    let curentValue = parseInt($(this).val());
    let _this = this
    let allquantities = $('.quantity-input')
    let quantities = allquantities.filter(element => {return allquantities[element] !== _this})
    let quantitiesSum = 0;
    let quantitiesLimit = parseInt($('.js-set-cart-list').attr('data-max-product'));
    quantities.each(function (element) {
        quantitiesSum = quantitiesSum + parseInt($(this).val());
    })
    if(quantitiesSum != 0){
        if(curentValue > (quantitiesLimit - quantitiesSum)){
            $(this).val(quantitiesLimit - quantitiesSum);
            $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
            $('.set-cart-error').show();
        }else{
            $('.set-cart-error').hide();
        }
    }else{
        if(curentValue > quantitiesLimit){
            $(this).val(quantitiesLimit);
            $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
            $('.set-cart-error').show();
        }else{
            $('.set-cart-error').hide();
        }
    }
});
$(document).on('change','.js-set-quantity-input',function (){
    const itemIndex = $(this).closest('.cart-item').attr('data-index');
    const quantity = parseInt($(this).val());
    let jsonSetCart = JSON.parse(localStorage.getItem("BananaSetCart"));
    const curentItem = jsonSetCart.find(element => element.position == parseInt(itemIndex));
    let quantities = $('.js-set-cart .quantity-input')
    let quantitiesSum = 0;
    let quantitiesLimit = parseInt($('.js-set-cart-list').attr('data-max-product'));
    quantities.each(function () {
        quantitiesSum += parseInt($(this).val());
    })
    if(quantity == 0){

        jsonSetCart.splice(curentItem.position, 1);

        jsonSetCart.forEach(function (item, index) {
            item.position = index;
        });
        localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
        setTimeout(initSetCart(), 1000);
    }else {
        let setCartItem = {
            id: curentItem.id,
            quantity: quantity,
            position: curentItem.position,
            variantJson: curentItem.variantJson,
            variantImage: curentItem.variantImage,
            productJson: curentItem.productJson
        }

        jsonSetCart.splice(curentItem.position, 0, setCartItem);
        jsonSetCart.splice(curentItem.position+1, 1);

        if(quantitiesSum <= quantitiesLimit) {
            localStorage.setItem('BananaSetCart', JSON.stringify(jsonSetCart));
            setTimeout(initSetCart(), 1000);
            $('.set-cart-error').hide();
        }else{
            $('.set-cart-error')[0].innerHTML=SetCart.cart_count_error_text;
            $('.set-cart-error').show();
        }
    }
})
$('.js-set-add').on('click',function (){
    let items=[];
    const cartItems = $( ".set-creator-cart-content .cart-item" );
    cartItems.each(function (item){
        items.push({'id':$(this).attr('data-variant'),"quantity":$(this).find('.quantity-input').val(),properties: {'Set_creator': `Product Set`}})

    })
    items = items.reverse()
    let formData = {
        items
    };

    fetch('/cart/add.js',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                // Error function
                errorMessage(response)
                return;
            }
            console.log("Succses")
            $('.set-cart-error').hide();
            $('.js-set-cart').removeClass('open');
            $('body').removeClass('set-cart-open');
            setTimeout(function (){
                updateCartDrawer(true);
                document.body.classList.add('overflow-hidden');
            },500)
            localStorage.removeItem('BananaSetCart');
            setTimeout(initSetCart(), 500);
        })
        .catch((error) => {
            console.log(error);
        });
});
function errorMessage(resp) {
    // alert(resp.description)
    console.log(resp.description);
    $('.set-cart-error')[0].innerHTML=resp.description;
    $('.set-cart-error').show();
}

// Set Fixes position of cart set
$(function() {
  var sidebar = $(".set-creator-cart");
  var offset = sidebar.offset();
  var topPadding = 110;
  var bottomOffset = $("footer").offset().top - $(window).height();
  
  $(window).scroll(function() {
      var scrollTop = $(window).scrollTop();
      if (window.innerWidth > 768 && scrollTop > offset.top) {
          if (scrollTop < bottomOffset) {
              sidebar.css({
                  position: 'fixed',
                  top: topPadding,
              });
          } else {
              sidebar.css({
                  position: 'absolute',
                  top: bottomOffset + topPadding
              });
          }
      } else {
          sidebar.css({
              position: 'static',
              top: 'auto'
          });
      };
  });
});

// Set tabs filter
$('.js-tabs-control .tabs-control-item').on('click',function (){
    if(!$(this).hasClass('active')){
        const tabId = $(this).attr('data-tab-id');
        $('.grid-tabs-item').addClass('hidden');
        $(`.grid-tabs-item[ data-tab="${tabId}"]`).removeClass('hidden');
        $('.tabs-control-item').removeClass('active');
        $(this).addClass('active');
    }
  });

$('.js-set-cart-open').on('click',function (){
   $('.js-set-cart').addClass('open');
   $('body').addClass('set-cart-open');
});
$('.js-set-cart-close').on('click',function (){
   $('.js-set-cart').removeClass('open');
   $('body').removeClass('set-cart-open');
});
$('.js-advantages-toggle-button').on('click',function (){
   $(this).closest('.set-creator-cart-advantages').toggleClass('open');
}); 
})

document.body.addEventListener("click", function (evt) {
    if(evt.target && evt.target.classList.contains('product-form__submit')){
        evt.preventDefault();
        let parent = evt.target.parentElement.parentElement;
        let productID = parent.querySelector('input.product-variant-id').value;
        let productVariantSize = parent.querySelector('.product-variant-size').value;

        if(productID){
                if (productVariantSize !== '1') {
                    document.querySelector('.swatch__label[data-swatch-variant="'+productID+'"]').click();
                }
                document.querySelector('.quick-add-modal[open] button.quick-add-modal__toggle').click()
                document.querySelector('button.add-to-set[data-product-id="'+productID+'"]').click();
                document.body.querySelector('quick-add-modal[open]').removeAttribute('open');
        }
        return false
    }
});